import { registerFeatureWithDescription } from "lib/features"
import { FEATURE_FLAG_SCHEDULE_ASSIGNMENTS_ID } from "./feature-flag-schedule-assignments-id.mjs"

/**
 * Gates schedule assignments on skill maps (FIQ-2457): assigning a whole library folder,
 * schedule or single task to a trade, and creating trades that have no skills.
 *
 * Assignments live in their own table, so switching the flag off only stops the cost
 * engine loading them; skill routing data is never rewritten.
 */
export const FEATURE_FLAG_SCHEDULE_ASSIGNMENTS = registerFeatureWithDescription({
    // 3003 and 3004 were used by earlier (removed or unmerged) flags, so skip them
    numericalId: 3005,
    id: FEATURE_FLAG_SCHEDULE_ASSIGNMENTS_ID,
    name: "Optimiser: schedule assignments",
    internalUseOnly: true,
    descriptionLines: [
        "Lets users assign a whole schedule library folder, a schedule or a single task to a trade on a skill map, instead of routing skill by skill.",
        "The most specific assignment wins (task, then schedule, then deepest folder); tasks with no assignment keep using skill routing.",
        "Also allows trades to be created with no skills, so contractors can be set up before schedules are assigned to them.",
    ],
})
